import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'

// axios 인스턴스 생성
const api = axios.create({
  baseURL: '', // vue proxy 사용
  timeout: 1000 * 60 * 30, // 30분
})

// =========================
// 요청 인터셉터 (토큰 자동 첨부)
// =========================
api.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()

    const token =
      authStore.accessToken ||
      localStorage.getItem('accessToken') ||
      sessionStorage.getItem('accessToken')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

// =========================
// 응답 인터셉터 (401 자동 로그아웃)
// =========================
api.interceptors.response.use(
  (response) => response,

  (error) => {
    const authStore = useAuthStore()

    if (error.response) {
      const status = error.response.status

      if (status === 401) {
        console.warn('🔴 401 발생 → 자동 로그아웃')

        authStore.logout()

        localStorage.removeItem('accessToken')
        localStorage.removeItem('user')
        sessionStorage.removeItem('accessToken')
        sessionStorage.removeItem('user')

        router.replace('/login')
      }
    }

    return Promise.reject(error)
  }
)

export default api